interface StickyObserverConfig {
	selector?: string;
	containerSelector?: string;
	innerSelector?: string;
	offset?: number;
	breakpoint?: number;
}

export const StickyObserver = {
	elements: [] as unknown as NodeListOf<HTMLElement>,

	config: {
		selector: '.sticky-column',
		containerSelector: '.sticky-container',
		innerSelector: '.sticky-column__inner',
		offset: 116,
		breakpoint: 992
	},

	init(config?: StickyObserverConfig): void {
		this.config = {
			...this.config,
			...config
		};

		this.elements = document.querySelectorAll<HTMLElement>(
			this.config.selector
		);

		if (!this.elements.length) {
			return;
		}

		this.bindClass();
		this.bindEvents();

		requestAnimationFrame(() => {
			this.update();
		});
	},

	bindClass(): void {
		this.update = this.update.bind(this);
	},

	bindEvents(): void {
		window.addEventListener('scroll', this.update, {
			passive: true
		});

		window.addEventListener('resize', this.update);
	},

	update(): void {
		this.elements.forEach((element) => {
			this.updateElement(element);
		});
	},

	updateElement(element: HTMLElement): void {
		const container = element.closest<HTMLElement>(
			this.config.containerSelector
		);

		const inner = element.querySelector<HTMLElement>(
			this.config.innerSelector
		);

		if (!container || !inner) {
			return;
		}

		if (window.innerWidth < this.config.breakpoint) {
			this.reset(element, inner);
			return;
		}

		const offset = this.config.offset;

		const containerRect = container.getBoundingClientRect();

		const containerTop = containerRect.top + window.scrollY;
		const containerBottom =
			containerTop + container.offsetHeight;

		const scrollTop = window.scrollY;
		const innerHeight = inner.offsetHeight;

		const stickyEnd =
			containerBottom - innerHeight - offset;

		element.style.setProperty(
			'--sticky-width',
			`${element.offsetWidth}px`
		);

		element.style.setProperty(
			'--sticky-offset',
			`${offset}px`
		);

		element.style.setProperty(
			'--sticky-bottom-top',
			`${container.offsetHeight - innerHeight}px`
		);

		if (
			scrollTop > containerTop - offset &&
			scrollTop < stickyEnd
		) {
			inner.classList.add('is-sticky');
			inner.classList.remove('is-sticky-bottom');
		}
		else if (scrollTop >= stickyEnd) {
			inner.classList.remove('is-sticky');
			inner.classList.add('is-sticky-bottom');
		}
		else {
			this.reset(element, inner);
		}
	},

	reset(
		element: HTMLElement,
		inner: HTMLElement
	): void {
		inner.classList.remove(
			'is-sticky',
			'is-sticky-bottom'
		);

		element.style.removeProperty('--sticky-width');
		element.style.removeProperty('--sticky-offset');
		element.style.removeProperty('--sticky-bottom-top');
	}
};
